export const environment = {
  clientID: '1',
};
